import { Customer } from '../../services/api'

interface BillingSectionProps {
  customer: Customer
}

const BillingSection: React.FC<BillingSectionProps> = ({ customer }) => {
  const isTrialMode = customer.subscription_status === 'trial' || !customer.stripe_subscription_id

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Billing & Subscription</h2>

        {isTrialMode ? (
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">Trial Mode</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              You're currently in trial mode. Campaigns will only send emails to your admin account.
            </p>
            <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded transition-colors">
              Upgrade to Starter - £20/month
            </button>
          </div>
        ) : (
          <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-6">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">Starter Plan</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              You're subscribed to the Starter plan at £20/month.
            </p>
            <div className="space-y-2">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Next billing date: {new Date(customer.subscription_valid_until || '').toLocaleDateString()}
              </p>
              <button className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 text-sm transition-colors">
                Manage Subscription →
              </button>
            </div>
          </div>
        )}
      </div>

      <div>
        <h3 className="font-medium text-gray-900 dark:text-white mb-3">Plan Features</h3>
        <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
          <li className="flex items-center">
            <svg className="w-5 h-5 text-green-500 dark:text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            2 campaigns per month
          </li>
          <li className="flex items-center">
            <svg className="w-5 h-5 text-green-500 dark:text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Up to 100 targets per campaign
          </li>
          <li className="flex items-center">
            <svg className="w-5 h-5 text-green-500 dark:text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            5 phishing templates
          </li>
          <li className="flex items-center">
            <svg className="w-5 h-5 text-green-500 dark:text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Email support
          </li>
        </ul>
      </div>
    </div>
  )
}

export default BillingSection
